exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-item{\n    cursor: pointer;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/mailer/mailer.component.css
// module id = ../../../../../src/app/mailer/mailer.component.css
// module chunks = main